module.exports = __webpack_public_path__ + "static/media/micro-site.4fc6d14e.mov";